export default {
    searchResults: null,
    searchResults1: null,
    searchResults2: null
}



// WEBPACK FOOTER //
// ./src/store/search/state.js